module.exports = __webpack_public_path__ + "img/symbol_10.6de8e4b9.png";